import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { GrupoDespesasService } from '../../../services/grupo-despesas.service';
import { ContascorrentesService } from '../../../services/contascorrentes.service';
import { lastValueFrom } from 'rxjs';
import { markFormGroupTouched } from '@utils';
import { TitulosFornecedoresServiceV2 } from '../../../services-v2/titulos-fornecedores/titulos-fornecedores-v2.service';
import { NFEntradaService } from '../../../services/nfentrada.service';

@Component({
  selector: 'app-modal-lancar-contas-a-pagar',
  templateUrl: './modal-lancar-contas-a-pagar.component.html',
  styleUrls: ['./modal-lancar-contas-a-pagar.component.css']
})
export class ModalLancarContasAPagarComponent extends ModalCadastroComponent implements OnInit {

  @ViewChild('modal', { static: true }) modal: any;

  form = new FormGroup({
    nfEntradaId: new FormControl(null),
    grupoDespesaId: new FormControl(null, [Validators.required]),
    contaPagadoraId: new FormControl(null, [Validators.required]),
    portadorId: new FormControl(null),
    centroCustoId: new FormControl(null),
  });
  gruposDespesas = [];
  contas = [];
  nfEntradaId: number;
  nfEntrada: any;

  constructor(
    private grupoDespesasService: GrupoDespesasService,
    private contasService: ContascorrentesService,
    private contasPagarService: TitulosFornecedoresServiceV2,
    private nfEntradaService: NFEntradaService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.nfEntradaId = this.prop.nfe;
    this.carregaDadosNFEntrada();
    this.carregaContasCorrentes();
    this.carregaGrupoDespesas();
  }

  handleOnClose(): void {
    this.closed.emit();
  }

  handleOnCancel(): void {
    this.hide();
  }

  async handleOnSave(): Promise<void> {
    markFormGroupTouched(this.form);

    if (this.form.invalid) {
      return;
    }

    try {
      this.loading['request'] = true;
      this.form.get('nfEntradaId')?.setValue(this.nfEntradaId);
      await this.contasPagarService.lancarContaPagarManifesto(this.form.value);
      this.hide();
    } catch (error) {
      console.error(error);
    } finally {
      this.loading['request'] = false;
    }

  }

  async carregaGrupoDespesas() {
    try {
      this.gruposDespesas = await lastValueFrom(this.grupoDespesasService.get());
    } catch (error) {
      console.error(error);
    }
  }

  async carregaContasCorrentes() {
    try {
      this.contas = await lastValueFrom(this.contasService.get());
    } catch (error) {
      console.error(error);
    }
  }

  async carregaDadosNFEntrada() {
    try {
      this.nfEntrada = await lastValueFrom(this.nfEntradaService.buscarDadosModalManifesto(this.nfEntradaId));
    } catch (error) {
      console.error(error);
    }
  }

  show(): void {
    this.modal.show();
  }

  private hide(): void {
    this.modal.hide();
  }
}
